import { apiRequest } from './httpClient';

export async function getCloverAdminSnapshot() {
  return apiRequest('getCloverAdminSnapshot', {
    method: 'GET',
    requireAuth: true,
  });
}

export async function saveCloverAdminSettings(settings) {
  return apiRequest('saveCloverAdminSettings', {
    method: 'POST',
    body: { settings },
    requireAuth: true,
  });
}

export async function upsertCloverMerchant(merchant) {
  return apiRequest('upsertCloverMerchant', {
    method: 'POST',
    body: { merchant },
    requireAuth: true,
  });
}

export async function deleteCloverMerchant(merchantId) {
  return apiRequest('deleteCloverMerchant', {
    method: 'POST',
    body: { merchantId },
    requireAuth: true,
  });
}
